module.exports = __webpack_public_path__ + "img/attack.49c56ef3.png";